import { createContext } from 'react'

const ScanInvoiceContext = createContext({})

export default ScanInvoiceContext
